export default __webpack_public_path__ + "static/media/Agile.526e1fda.png";